import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
  d: "M3 19h18V5H3v14zM13 8h2v8h-2V8zM9 8h2v8H9V8z",
  opacity: ".3"
}), /*#__PURE__*/React.createElement("path", {
  d: "M21 3H3c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H3V5h18v14zM9 8h2v8H9zm4 0h2v8h-2z"
})), 'PausePresentationTwoTone');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/PausePresentationTwoTone.js
// module id = 5232
// module chunks = 2